import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeDividendTransformer  {
    _originalTypeClassName = "zERP.BO.BackOfficeDividendTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeDividendTransformer.translate = translateService;
}
this.BackOfficeDividendTransformerKey = null;
this._key = this.BackOfficeDividendTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeDividendTransformerKey:any;
get BackOfficeDividendTransformerKey(): any {
    return this._BackOfficeDividendTransformerKey;
  }
set BackOfficeDividendTransformerKey(value: any) {
    this._BackOfficeDividendTransformerKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeDividendTransformerKey == null || $this.BackOfficeDividendTransformerKey == 0;
            }


}